import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormGroup, Label, Select, SelectOption } from "@mwi/ui";
import { updateFormState } from "slices/registration";
import { RootState } from "store";
import { gtmEvent } from "helpers/gtm";

type Inputs = {
  vet_site: string;
};

const RegistrationPractice = () => {
  const dispatch = useDispatch();

  const { formState, locations } = useSelector((state: RootState) => ({
    formState: state.registration.formState,
    locations: state.registration.locations,
  }));

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      vet_site: formState.vet_site,
    },
  });

  const submitForm = (data: Inputs) => {
    dispatch(
      updateFormState({
        vet_site: data.vet_site,
      }),
    );
  };

  useEffect(() => gtmEvent({ name: "onRegFlowVetLocationStepPageView" }), []);

  return (
    <div className="py-6">
      <h1 className="text-4xl font-bold tablet:text-6xl">
        Which vet practice will you visit?
      </h1>

      <p className="mt-6 tablet:mt-8 tablet:text-lg">
        This is where you&apos;ll be registered.
      </p>

      <form
        className="flex flex-col flex-grow mt-8 tablet:mt-12"
        onSubmit={handleSubmit(submitForm)}
      >
        <FormGroup error={errors?.vet_site?.message}>
          <Label>Vet Practice</Label>
          <Select
            name="vet_site"
            placeholder="Select vet practice site"
            control={control}
          >
            {(locations ?? []).map((l) => (
              <SelectOption key={l.id} value={l.id}>
                {l.name}
              </SelectOption>
            ))}
          </Select>
        </FormGroup>

        <div className="mt-auto tablet:mt-12 tablet:max-w-xs">
          <Button type="submit" block>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RegistrationPractice;
